import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Checkbox } from '@/components/ui/checkbox';
import { InertiaFormField } from '@/components/ui/form';
import { Label } from '@/components/ui/label';
import { Link } from '@/components/ui/link';
import { useForm } from '@inertiajs/react';
import { FormEventHandler } from 'react';

export default function LoginForm({
  onClickSignUp,
}: {
  onClickSignUp: () => void;
}) {
  const form = useForm({
    username: '',
    password: '',
    remember: false,
  });

  const submit: FormEventHandler = (e) => {
    e.preventDefault();

    form.post(route('login'), {
      onSuccess: () => form.reset('password'),
    });
  };

  return (
    <Card className="h-fit w-full md:max-w-[20rem]">
      <CardHeader>
        <CardTitle className="text-2xl">Đăng nhập</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={submit}>
          <div className="space-y-5">
            <InertiaFormField
              form={form}
              fieldName="username"
              displayName="Tên đăng nhập"
              type="username"
            />
            <InertiaFormField
              form={form}
              fieldName="password"
              displayName="Mật khẩu"
              type="password"
            />
            <div className="flex items-center space-x-2">
              <Checkbox
                id="remember"
                className="h-4 w-4"
                defaultChecked={form.data.remember}
                onCheckedChange={(val) => form.setData('remember', !!val)}
              />
              <Label htmlFor="remember">Ghi nhớ đăng nhập</Label>
            </div>
            <div className="w-full">
              <Button className="w-full" loading={form.processing}>
                Đăng nhập
              </Button>
            </div>
          </div>
        </form>
        <p className="mt-2 text-sm text-muted-foreground">
          Chưa có tài khoản? <Link onClick={onClickSignUp}>Đăng ký</Link>
        </p>
      </CardContent>
    </Card>
  );
}
